import React from 'react';
import PropTypes from 'prop-types';
import {
  DropdownList, DateTimePicker, Multiselect, SelectList,
} from 'react-widgets';
import { Calendar } from 'primereact/calendar';
import TagsInput from 'react-tagsinput';
import Toggle from 'react-toggle';
import { AssessmentConstants } from '../shared/Constants';

export const renderInput = (props) => {
  const {
    input,
    type,
    meta: { touched, error, warning },
    ...rest
  } = props;
  return (
    <div className={touched && error ? 'has-error' : ''}>
      <input {...input} type={type} {...rest} />
      {touched
        && ((error && <span style={{ color: '#ce4844' }}>{error}</span>)
          || (warning && <span style={{ color: '#f0ad4e' }}>{warning}</span>))}
    </div>
  );
};

renderInput.propTypes = {
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  type: PropTypes.string.isRequired,
};

export const renderCheckboxInput = (props) => {
  const {
    input,
    type,
    meta: { touched, error, warning },
    name,
    id,
    textcomp,
    ...rest
  } = props;
  return (
    <div className={touched && error ? 'has-error' : ''}>
      <div className="checkbox">
        <input {...input} id={id} {...rest} type="checkbox" />
        <label htmlFor={id}>{textcomp}</label>
      </div>
      {touched
        && ((error && <span style={{ color: '#ce4844' }}>{error}</span>)
          || (warning && <span style={{ color: '#f0ad4e' }}>{warning}</span>))}
    </div>
  );
};

renderCheckboxInput.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  textcomp: PropTypes.string.isRequired,
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
};

export const renderTextArea = (props) => {
  const {
    input,
    type,
    meta: { touched, error, warning },
    ...rest
  } = props;
  return (
    <div className={touched && error ? 'has-error' : ''}>
      <textarea {...input} type={type} {...rest} />
      {touched
        && ((error && <span style={{ color: '#ce4844' }}>{error}</span>)
          || (warning && <span style={{ color: '#f0ad4e' }}>{warning}</span>))}
    </div>
  );
};


renderTextArea.propTypes = {
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  type: PropTypes.string.isRequired,
};

const getFilter = (filter) => {
  if (filter) {
    if (filter === true) {
      return 'contains';
    }
    return filter;
  }
  return false;
};
export const renderDropdownList = (props) => {
  const {
    input,
    meta: { touched, error, warning },
    filter,
    onCustomChange,
    ...rest
  } = props;
  const definedFilter = getFilter(filter);
  const value = input.value ? input.value : null;
  return (
    <div className="dropdown-field-wrapper">
      <DropdownList
        {...input}
        {...rest}
        value={value}
        onChange={(...args) => {
          if (onCustomChange) {
            onCustomChange(...args);
          }
          input.onChange(...args);
        }}
        filter={definedFilter}
      />
      {touched
        && ((error && <span style={{ color: '#ce4844' }}>{error}</span>)
          || (warning && <span style={{ color: '#f0ad4e' }}>{warning}</span>))}
    </div>
  );
};

renderDropdownList.propTypes = {
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  filter: PropTypes.string,
  onCustomChange: PropTypes.func,
};

renderDropdownList.defaultProps = {
  filter: '',
  onCustomChange: PropTypes.func,
};

export const renderDateTimePicker = ({
  input, time, dateTimeFormat, placeholder,
}) => (
  <DateTimePicker
    {...input}
    // onChange={input.onChange}
    time={time}
    format={dateTimeFormat}
    placeholder={placeholder}
    value={!input.value ? null : new Date(input.value)}
  />
);

renderDateTimePicker.propTypes = {
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  time: PropTypes.objectOf(PropTypes.any).isRequired,
  dateTimeFormat: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};

const limitDay = new Date();
limitDay.setDate(limitDay.getDate() + AssessmentConstants.MAX_EXPANDS_TIME);
export const renderDateTimePickerforAssessment = ({
  input: { onChange, value },
  time,
  dateTimeFormat,
  disabled,
}) => (
  <Calendar
    showTime={time}
    value={value}
    minDate={new Date()}
    maxDate={limitDay}
    disabled={disabled}
    onChange={onChange}
    dateFormat={dateTimeFormat}
  />
);

renderDateTimePickerforAssessment.propTypes = {
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  time: PropTypes.objectOf(PropTypes.any).isRequired,
  dateTimeFormat: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

renderDateTimePickerforAssessment.defaultProps = {
  disabled: false,
};

export const renderSwitch = (props) => {
  const {
    input: { onChange, name },
    disabled,
    defaultChecked,
    className,
    icons,
    ...rest
  } = props;
  const isVisibleIcon = icons !== false;
  return (
    <Toggle
      name={name}
      onChange={onChange}
      disabled={disabled}
      icons={isVisibleIcon}
      defaultChecked={defaultChecked}
      className={`tgl ${className || ''}`}
      {...rest}
    />
  );
};

renderSwitch.propTypes = {
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  icons: PropTypes.objectOf(PropTypes.any),
  disabled: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  className: PropTypes.string,
};

renderSwitch.defaultProps = {
  disabled: false,
  icons: null,
  defaultChecked: false,
  className: false,
};

export const renderMultiselect = (props) => {
  const {
    input,
    meta: { touched, error, warning },
    ...rest
  } = props;
  const { onBlur, value, onChange } = input;
  return (
    <div>
      <Multiselect onBlur={() => onBlur()} value={value || []} onChange={onChange} {...rest} />
      {touched
        && ((error && <span style={{ color: '#ce4844' }}>{error}</span>)
          || (warning && <span style={{ color: '#f0ad4e' }}>{warning}</span>))}
    </div>
  );
};

renderMultiselect.propTypes = {
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
};

export const renderTagsInput = (props) => {
  const {
    input,
    meta: { error, warning },
    className,
    ...rest
  } = props;
  const { value, onChange } = input;
  return (
    <div>
      <TagsInput value={value || []} onChange={onChange} className={`react-tagsinput ${className || ''}`} {...rest} />
      {(error && <span style={{ color: '#ce4844' }}>{error}</span>)
        || (warning && <span style={{ color: '#f0ad4e' }}>{warning}</span>)}
    </div>
  );
};

renderTagsInput.propTypes = {
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
};

renderTagsInput.defaultProps = {
  className: '',
};

export const renderSelectList = (props) => {
  const {
    input,
    meta: { error, warning },
    className,
    customChange,
    ...rest
  } = props;
  const { value, onChange } = input;
  return (
    <div>
      <SelectList
        value={value || []}
        onChange={async (...args) => {
          await onChange(...args);
          if (customChange) {
            customChange(args);
          }
        }}
        {...rest}
      />
      {(error && <span style={{ color: '#ce4844' }}>{error}</span>)
        || (warning && <span style={{ color: '#f0ad4e' }}>{warning}</span>)}
    </div>
  );
};

renderSelectList.propTypes = {
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
  customChange: PropTypes.func,
};

renderSelectList.defaultProps = {
  className: '',
  customChange: null,
};
